// SSR bridge selector — used ONLY by Widget.jsx to read hydrated state once on mount
export const selectIncentivesSearch = (state) => state.incentivesSearch;
